var MINI_DS_PREFIX, deriveHandoutIdFromTopicId;

MINI_DS_PREFIX = require('lib/doc_prefixes').miniDsDoc;

deriveHandoutIdFromTopicId = function(topicId) {
  if (!topicId) {
    return;
  }
  return "" + MINI_DS_PREFIX + (uuid.v5(topicId, uuid.NIL));
};

module.exports = {
  deriveHandoutIdFromTopicId: deriveHandoutIdFromTopicId
};
